import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import SEO from './components/SEO';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import StudyAbroadPage from './pages/StudyAbroadPage';
import WorkAbroadPage from './pages/WorkAbroadPage';
import CanadaPRPage from './pages/CanadaPRPage';
import AustraliaPRPage from './pages/AustraliaPRPage';
import NewZealandPRPage from './pages/NewZealandPRPage';
import PortugalPRPage from './pages/PortugalPRPage';
import AustraliaCareWorkforcePage from './pages/AustraliaCareWorkforcePage';
import AustraliaCareWorkforceIntakePage from './pages/AustraliaCareWorkforceIntakePage';
import AboutUs from './pages/AboutUs';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import BlogPage from './pages/BlogPage';
import PracticalGuideStudyingAbroad from './pages/blog/PracticalGuideStudyingAbroad';
import WorkingAbroadPreparation from './pages/blog/WorkingAbroadPreparation';
import InformedDecisionsStudyWorkAbroad from './pages/blog/InformedDecisionsStudyWorkAbroad';
import Terms from './pages/Terms';
import Policy from './pages/Policy';
import Cookie from './pages/Cookie';
import UnsubscribePage from './pages/UnsubscribePage';
import InvoicePayments from './pages/InvoicePayments';

// Internal tooling — gated, not linked from the public nav.
import ManageUnsubscribesPage from './pages/ManageUnsubscribesPage';
import ManageInvoices from './pages/ManageInvoices';

import NotFound from './pages/NotFound';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <SEO />
      <Header />
      <Routes>
        {/* Public */}
        <Route path="/" element={<HomePage />} />
        <Route path="/study-abroad" element={<StudyAbroadPage />} />
        <Route path="/work-abroad" element={<WorkAbroadPage />} />
        <Route path="/permanent-residency/canada" element={<CanadaPRPage />} />
        <Route path="/permanent-residency/australia" element={<AustraliaPRPage />} />
        <Route path="/permanent-residency/new-zealand" element={<NewZealandPRPage />} />
        <Route path="/permanent-residency/portugal" element={<PortugalPRPage />} />
        <Route
          path="/permanent-residency/australia-care-workforce"
          element={<AustraliaCareWorkforcePage />}
        />
        <Route
          path="/forms/australia-care-workforce-intake"
          element={<AustraliaCareWorkforceIntakePage />}
        />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />

        {/* Blog */}
        <Route path="/blog" element={<BlogPage />} />
        <Route
          path="/blog/practical-guide-studying-abroad"
          element={<PracticalGuideStudyingAbroad />}
        />
        <Route path="/blog/working-abroad-preparation" element={<WorkingAbroadPreparation />} />
        <Route
          path="/blog/informed-decisions-study-work-abroad"
          element={<InformedDecisionsStudyWorkAbroad />}
        />

        {/* Legal */}
        <Route path="/terms-of-service" element={<Terms />} />
        <Route path="/privacy-policy" element={<Policy />} />
        <Route path="/cookie-policy" element={<Cookie />} />

        {/* Self-service */}
        <Route path="/unsubscribe" element={<UnsubscribePage />} />
        <Route path="/invoice/payments" element={<InvoicePayments />} />

        {/* Internal tooling */}
        <Route path="/manage/unsubscribes" element={<ManageUnsubscribesPage />} />
        <Route path="/invoice/manage" element={<ManageInvoices />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
